export default {"src":"/_next/static/media/Instagram.97779ff3.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};